module.exports = __webpack_public_path__ + "static/img/10_pro.32b3b34.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rz/10_pro.jpg
// module id = SYjE
// module chunks = 0